module.exports = __webpack_public_path__ + "static/img_1967-ad837395b73146be28b21b36eeba59e2.webp";